import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { AuthProvider } from './contexts/AuthContext';
import { StreamProvider } from './contexts/StreamContext';
import Navbar from './components/Navigation/Navbar';
import RouteConfig from './components/Navigation/RouteConfig';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import { GameProvider } from './contexts/GameContext';

ReactGA.initialize('G-JEGJBXCHEC');

// Inner component that can use useLocation (must be inside Router)
const AppContent = () => {
  const location = useLocation();

  // Hide nav/footer for invite view (recipient view) and fullscreen stream pages
  const hideNavigation = location.pathname.includes('/Playground/Inviteapp/invite/');
  const hideFooter = hideNavigation || location.pathname.startsWith('/stream/');

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      {!hideNavigation && <Navbar />}
      <main className={`flex-1 flex flex-col w-full ${!hideNavigation ? 'pt-[69px]' : ''}`}>
        <div className="flex-1">
          <RouteConfig />
        </div>
        {!hideFooter && <Footer />}
      </main>
      <CookieBanner />
    </div>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <GameProvider>
        <StreamProvider>
          <AppContent />
        </StreamProvider>
      </GameProvider>
    </AuthProvider>
  );
};

export default App;